import React, { FunctionComponent, useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select, { SelectChangeEvent, SelectProps } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

type Props = {
  variants: any[];
  defaultValue?: any[];
  selectProps?: SelectProps<any[]>;
  label?: string;
  onChange?: (event: SelectChangeEvent<any[]>) => void;
};
export const MultiSelectCheckmark: FunctionComponent<Props> = ({
  variants,
  label,
  selectProps,
  onChange,
  defaultValue,
}) => {
  const [variantName, setVariantName] = useState<any[]>(
    (defaultValue && variants.filter((v) => defaultValue.includes(v.id))) || []
  );

  const handleChange = (event: SelectChangeEvent<any[]>) => {
    const {
      target: { value },
    } = event;
    const val: any[] = value as any[];
    let duplicateRemoved: any[] = [];

    val.forEach((item) => {
      if (
        duplicateRemoved.findIndex((o) => {
          if (typeof o === "string") {
            return o === item;
          } else {
            return o.id === item.id;
          }
        }) >= 0
      ) {
        duplicateRemoved = duplicateRemoved.filter((x) =>
          typeof x === "string" ? x === item : x.id === item.id
        );
      } else {
        duplicateRemoved.push(item);
      }
    });
    onChange?.(event);
    setVariantName(duplicateRemoved);
  };

  return (
    <FormControl sx={{ width: "100%" }}>
      <InputLabel id={label}>{label}</InputLabel>
      <Select
        {...selectProps}
        labelId={label}
        multiple
        value={variantName}
        onChange={handleChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => selected.map((x) => x.name).join(", ")}
        MenuProps={MenuProps}
      >
        {variants.map((variant) => (
          <MenuItem key={JSON.stringify(variant)} value={variant}>
            <Checkbox
              checked={
                variantName.findIndex((item) =>
                  typeof item === "string"
                    ? item === variant
                    : item.id === variant.id
                ) >= 0
              }
            />
            <ListItemText primary={variant.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
